import { useState } from 'react';
import { ShopifyService, UpdateProductData } from '../services/shopify/ShopifyService';
import { productService } from '../services/ProductService';

export function useShopify() {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const shopifyService = ShopifyService.getInstance();

  const publishToShopify = async (
    storeName: string,
    productId: string,
    documentId: string,
    title: string,
    description: string,
    bulletPoints: string[],
    pageTitle?: string,
    metaDescription?: string
  ) => {
    setIsLoading(true);
    setError(null);
    try {
      const store = await shopifyService.getStoreConfig(storeName);
      const updateData: UpdateProductData = {
        title,
        body_html: description,
        bulletPoints,
        pageTitle,
        metaDescription
      };
      await shopifyService.updateProduct(store, productId, updateData);
      // Update publish timestamp in Firestore
      await productService.updatePublishTimestamp(documentId, 'shopify');
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : 'Failed to publish to Shopify';
      setError(errorMessage);
      throw err;
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    error,
    publishToShopify
  };
}